export interface IReviewVendor {
  name: string;
  code: string;
}

export class ReviewVendor implements IReviewVendor {
  reviewVendorId: number;
  name: string;
  code: string;
}
